import { render, staticRenderFns } from "./commentsUl_flat_update.vue?vue&type=template&id=fee4c4d6&scoped=true&"
import script from "./commentsUl_flat_update.vue?vue&type=script&lang=js&"
export * from "./commentsUl_flat_update.vue?vue&type=script&lang=js&"
import style0 from "./commentsUl_flat_update.vue?vue&type=style&index=0&id=fee4c4d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee4c4d6",
  null
  
)

export default component.exports